import API from "../api/double12";



let channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
let ua = window.navigator.userAgent.toLowerCase() || '';
let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('linux') > -1; // 安卓
let inMiguApp = ua.indexOf('miguplay') > -1; //快游端内

// 将时间格式化为yyyyMMddHHmmss.SSS
Date.prototype.format = function (fmt) { //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S+": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
//客户端登录
function recordLoginInfo (params) {
  const { opType, appType, opTime , rese1, rese3} = params;
  var headers = {
    "appChannel": channel,
    "appType": appType || 0,
    "appVersion": '',
    "platform": isAndroid ? 1 : 2,
    "systemVersion": getMobileType().os ? getMobileType().os : '',
    "networkType": '',
    "carrier": '',
    "userType": window.localStorage.getItem('userId') ? 1 : 0,
    "msisdn": window.localStorage.getItem('phone') ? window.localStorage.getItem('phone') : '',
    "identityId": window.localStorage.getItem('identityId') ? window.localStorage.getItem('identityId') : '',
    "passId": window.localStorage.getItem('passId') ? window.localStorage.getItem('passId') : '',
    "imei": '',
    "imsi": '',
    "idfa": '',
    "cookieMd5": '',
    "deviceId": window.sessionStorage.getItem('appDeviceId') || '',
    "clientIp": '',
    "brand": getMobileType().brand ? getMobileType().brand : '',
    "model": getMobileType().model ? getMobileType().model : 'iphone',
    "screen": '',
    "city": '',
    "address": '',
    "time": new Date().format("yyyyMMddHHmmssSSS"),
    "userId": window.localStorage.getItem('userId') ? window.localStorage.getItem('userId') : '',
    "userToken": window.localStorage.getItem('userToken') ? window.localStorage.getItem('userToken') : '',
    ...params,
  }
  let param = {
    headers: {
      "opTime": opTime || new Date().format("yyyyMMddHHmmssSSS"),
      ...headers 
    },
    data: {
      "opType": opType,  //操作类型：1: 进入前台；2: 登录；
      "playTime": "",
      'rese1': rese1,
      'rese2':  window.location.href,
      'rese3': rese3 || ''
    }
  }
  API.postJinFenLogin(param).then(resp => {
 
  }).catch((err) => {
    console.error(err)
  })
}
// 行为事件埋点
function recordEventAction (data) {

    let recordData = {
      "opTime": new Date().format("yyyyMMddHHmmss.SSS"),
      ...data
    }
    var storeArr = window.localStorage.getItem('recordData') ? JSON.parse(window.localStorage.getItem('recordData')) : []
    storeArr.push(recordData)
    window.localStorage.setItem('recordData', JSON.stringify(storeArr))
    recordEventInfo();
}


// 记录经分统计 - 客户端事件
function recordEventInfo (appType = 0) {
  var headers = {
    "appChannel": channel,
    "appType": appType,
    "appVersion": '',
    "platform": isAndroid ? 1 : 2,
    "systemVersion": getMobileType().os ? getMobileType().os : '',
    "networkType": '',
    "carrier": '',
    "userType": window.localStorage.getItem('userId') ? 1 : 0,
    "msisdn": "",
    "identityId": window.localStorage.getItem('identityId') ? window.localStorage.getItem('identityId') : '',
    "passId": window.localStorage.getItem('passId') ? window.localStorage.getItem('passId') : '',
    "imei": '',
    "imsi": '',
    "idfa": '',
    "cookieMd5": '',
    "deviceId": window.localStorage.getItem('deviceId') || '',
    "clientIp": '',
    "brand": getMobileType().brand ? getMobileType().brand : '',
    "model": getMobileType().model ? getMobileType().model : '',
    "screen": '',
    "city": '',
    "address": '',
    "time": new Date().format("yyyyMMddHHmmssSSS"),
    "userId": window.localStorage.getItem('userId') ? window.localStorage.getItem('userId') : '',
    "userToken": window.localStorage.getItem('userToken') ? window.localStorage.getItem('userToken') : '',
    'headerrese1':inMiguApp ? 1 : 0,
  }
  let recordData = window.localStorage.getItem('recordData') ? JSON.parse(window.localStorage.getItem('recordData')) : []
  let param = {
    headers: {
      ...headers 
    },
    data: {
      "location": []
    }
  }
  
  for (let i = 0; i < recordData.length; i++) {
    let item = {
      "opTime": recordData[i].opTime,   // 时间
      "eventType": recordData[i].eventType,  // 事件类型
      "eventDesc": '',  
      "extra": {
        "pageName": recordData[i].pageName,  // 页面名字
        "page": '',
        "index": '',
        "topicIndex": '',
        "topicName": recordData[i].topicName ? recordData[i].topicName : '', // 资讯ID
        "labelName": '',
        "gameId": recordData[i].gameId ? recordData[i].gameId : '',  // 游戏ID
        "reason": '',
        "definition": '',
        "network": '',
        "keyword": recordData[i].keyword ? recordData[i].keyword : '', // 输入框的输入内容
        "rese1": '',
        "rese2": window.location.href,
        "rese3": recordData[i].rese3 ? recordData[i].rese3 : 0,
        "rese4": recordData[i].rese4 ? recordData[i].rese4 : '',
        "rese5": recordData[i].rese5 ? recordData[i].rese5 : '',
        "rese6": recordData[i].rese6 ?recordData[i].rese6:'',
        "rese7": recordData[i].rese7 ?recordData[i].rese7:'',
        "rese8": recordData[i].rese8 ?recordData[i].rese8:'',  // 事件描述
        "rese9": recordData[i].rese9 ?recordData[i].rese9:'',
        "rese10": window.sessionStorage.getItem('appDeviceId') || '', // 客户端设备id
        "rese11": recordData[i].rese11 ?recordData[i].rese11:'',
        "rese12": recordData[i].rese12 ?recordData[i].rese12:'',
        "rese13": recordData[i].rese13 ?recordData[i].rese13:'',
        ...recordData[i],
      }
    }
    param.data.location.push(item)
  }

  API.postJinFenEvent(param).then(resp => {
    window.localStorage.removeItem("recordData")
  }).catch((err) => {
    console.error(err)
  })

}

// 记录经分统计 - 游戏启动和下载事件
function recordPlayInfo (game, operation) {
  var headers = {
    "appChannel": channel,
    "appType": 4,
    "appVersion": '',
    "platform": isAndroid ? 1 : 2,
    "systemVersion": getMobileType().os ? getMobileType().os : '',
    "networkType": '',
    "carrier": '',
    "userType": window.localStorage.getItem('userId') ? 1 : 0,
    "msisdn": window.localStorage.getItem('phone') ? window.localStorage.getItem('phone') : '',
    "identityId": window.localStorage.getItem('identityId') ? window.localStorage.getItem('identityId') : '',
    "passId": window.localStorage.getItem('passId') ? window.localStorage.getItem('passId') : '',
    "imei": '',
    "imsi": '',
    "idfa": '',
    "cookieMd5": '',
    "deviceId": window.localStorage.getItem('deviceId') ? window.localStorage.getItem('deviceId') : '',
    "clientIp": '',
    "brand": getMobileType().brand ? getMobileType().brand : '',
    "model": getMobileType().model ? getMobileType().model : '',
    "screen": '',
    "city": '',
    "address": '',
    "time": new Date().format("yyyyMMddHHmmssSSS"),
    "userId": window.localStorage.getItem('userId') ? window.localStorage.getItem('userId') : '',
    "userToken": window.localStorage.getItem('userToken') ? window.localStorage.getItem('userToken') : '',
    "opType" : game.opType
  }

  console.log('game.....', game)
  let protoData = {
    "uid": window.localStorage.getItem('userId') ? window.localStorage.getItem('userId') : 0,
    'imei': '',
    "network": '',
    "channelId": channel,
    "gameId" : game.gameId,
    "version": '0.0.0',
    "phone": window.localStorage.getItem('phone') ? window.localStorage.getItem('phone') : '',
    "systemVersion": '',
    "carrier": '',
    "userType": window.localStorage.getItem('userId') ? 1 : 0,
    "identityId": window.localStorage.getItem('identityId') ? window.localStorage.getItem('identityId') : '',
    "passId": window.localStorage.getItem('passId') ? window.localStorage.getItem('passId') : '',
    "imsi": '',
    "idfa": '',
    "cookieMd5": '',
    "deviceId": window.localStorage.getItem('deviceId') ? window.localStorage.getItem('deviceId') : '',
    "clientIp": '',
    "brand": getMobileType().brand ? getMobileType().brand : '',
    "model": getMobileType().model ? getMobileType().model : '',
    "screen": '',
    "city": '',
    "address": '',
    "userIdType": window.localStorage.getItem('userId') ? 1 : 0,
    "gameType" : game.gameType,
    "appType": 4,
    "opType" : game.opType,
    "playTime": game.playTime,
    "sessionId" : ''
  }

  let eventData = {
    "timestamp": new Date().getTime()
  }
  if (game.opType == '4') {
    eventData.playInterval = game.playTime
  }
  let param = {
    headers: {
      "opTime": new Date().format("yyyyMMddHHmmss.SSS"),
      ...headers 
    },
    data: {
      "cid": new Date().getTime().toString() + getRandom(9) + (game.gameType == 1 ? "c" : "e"),
      // "bid": game.gameType == 1 ? 'DP393BT2727' : 'DM333BT6527',  //测试环境
      "bid": game.gameType == 1 ? 'DP333BP3587' : 'DM433BP3527',  //正式环境
      "pkgName": game.pkgName,  // 包名
      "pkgVersion": '0.0.0',
      "idc": '0',
      "clientType": isAndroid ? 7 : 6,
      "type": game.opType == '4' ? 'StreamingStopped' : 'StreamingStarted',   // 事件类型
      "event": eventData,
      "protoData": base64_encode(JSON.stringify(protoData))
    }
  }
  API.postJinFenPlay(param).then(resp => {
    console.log('recordPlayInfo  param', param)
    console.log('recordPlayInfo  resp.data', resp.data)
  }).catch((err) => {
    console.error(err)
  })
}

function setDeviceId () {
  if (!window.localStorage.getItem('deviceId')) {
    window.localStorage.setItem('deviceId', 'deviceId-' + new Date().getTime().toString() + '-' + getRandom(9))
  }
};

function getMobileType () {
  //判断数组中是否包含某字符串  
  Array.prototype.contains = function(needle) {  
    for (i in this) {  
      this[i] = this[i].toString();
      if (this[i].indexOf(needle) > 0)  
        return i 
    }  
    return -1
  }  
  return {
    os:'phone',
    brand:'',
    model:''


  }
  let device_type = window.navigator.userAgent
  let md = new MobileDetect(device_type)
  let os = md.os() // 获取手机系统  
  let brand = '' // 获取手机品牌
  let model = '' // 获取手机型号
  // alert(device_type)
  // Mozilla/5.0 (iPhone; CPU iPhone OS 10_3_1 like Mac OS X) AppleWebKit/603.1.30 (KHTML, like Gecko) Version/10.0 Mobile/14E304 Safari/602.1
  // Mozilla/5.0 (Linux; Android 5.0; SM-G900P Build/LRX21T) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/66.0.3359.181 Mobile Safari/537.36

  if (os == 'iOS') {//ios系统的处理  
    os = md.os() + md.version('iPhone')  
    brand = md.mobile() 
    model = md.mobile()  
  } else if (os == 'AndroidOS') {
    os = md.os() + md.version('Android')  
    let arr = device_type.split(';') 
    var i = arr.contains('Build/')  
    if (i > -1) {  
      brand = md.mobile() 
      model = arr[i].substring(0, arr[i].indexOf('Build/'))
    }  
  }  
  let data = {
    os: os,   //操作系统版本号
    brand: brand,  //手机品牌
    model: model   //手机型号
  }
  return data
}

function base64_encode(str) { // 编码，配合encodeURIComponent使用
  var c1, c2, c3;
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var i = 0, len = str.length, strin = '';
  while (i < len) {
    c1 = str.charCodeAt(i++) & 0xff;
    if (i == len) {
      strin += base64EncodeChars.charAt(c1 >> 2);
      strin += base64EncodeChars.charAt((c1 & 0x3) << 4);
      strin += "==";
      break;
    }
    c2 = str.charCodeAt(i++);
    if (i == len) {
      strin += base64EncodeChars.charAt(c1 >> 2);
      strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      strin += base64EncodeChars.charAt((c2 & 0xF) << 2);
      strin += "=";
      break;
    }
    c3 = str.charCodeAt(i++);
    strin += base64EncodeChars.charAt(c1 >> 2);
    strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
    strin += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
    strin += base64EncodeChars.charAt(c3 & 0x3F)
  }
  return strin
}

function base64_decode(input) { // 解码，配合decodeURIComponent使用
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var output = "";
  var chr1, chr2, chr3;
  var enc1, enc2, enc3, enc4;
  var i = 0;
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  while (i < input.length) {
    enc1 = base64EncodeChars.indexOf(input.charAt(i++));
    enc2 = base64EncodeChars.indexOf(input.charAt(i++));
    enc3 = base64EncodeChars.indexOf(input.charAt(i++));
    enc4 = base64EncodeChars.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 != 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 != 64) {
      output = output + String.fromCharCode(chr3);
    }
  }
  return utf8_decode(output);
}

function utf8_decode(utftext) { // utf-8解码
  var string = '';
  let i = 0;
  let c = 0;
  let c1 = 0;
  let c2 = 0;
  while (i < utftext.length) {
    c = utftext.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if ((c > 191) && (c < 224)) {
      c1 = utftext.charCodeAt(i + 1);
      string += String.fromCharCode(((c & 31) << 6) | (c1 & 63));
      i += 2;
    } else {
      c1 = utftext.charCodeAt(i + 1);
      c2 = utftext.charCodeAt(i + 2);
      string += String.fromCharCode(((c & 15) << 12) | ((c1 & 63) << 6) | (c2 & 63));
      i += 3;
    }
  }
  return string;
}

//获取指定位数的随机数
function getRandom(num) {
  var random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1));
  return random
}

module.exports = {
  recordEventInfo: recordEventInfo,
  recordLoginInfo: recordLoginInfo,
  recordPlayInfo: recordPlayInfo,
  getMobileType: getMobileType,
  setDeviceId: setDeviceId,
  recordEventAction: recordEventAction,
  base64_encode: base64_encode,
  base64_decode: base64_decode
}


// WEBPACK FOOTER //
// ./src/utils/addClientEvent.js